import React, { useState } from "react";
import logo from "../assets/images/logo.jpg";
import { Link } from "react-router-dom";
// import close from '../assets/svg/close.svg'
import close from "../assets/svg/free-icon-minimize-sign-6057365 2.svg";
import minimize from "../assets/svg/icon-minimize-sign.svg";
import rollUp from "../assets/svg/icon_roll up.svg";
import home from "../assets/svg/icon-home.svg";
import document from "../assets/svg/icon-document.svg";
import textDocument from "../assets/svg/icon-text-document.svg";
import remove from "../assets/svg/icon-cross-remove.svg";
import document1 from "../assets/svg/icon-document-1.svg";
import floppyDisk from "../assets/svg/icon-floppy-disk.svg";
import semicircular from "../assets/svg/icon-semicircular-arrow.svg";
import check from "../assets/svg/icon-check-mark.svg";
import recycling from "../assets/svg/icon-recycling-paper.svg";
import binoculars from "../assets/svg/icon-binoculars.svg";
import magnifier from "../assets/svg/icon-magnifier.svg";
import sort from "../assets/svg/icon-sort-alphabetically.svg";
import printer from "../assets/svg/icon-printer.svg";
import excel from "../assets/svg/icon-excel.svg";
import file from "../assets/svg/icon-file-and-folder.svg";
import paperclip from "../assets/svg/icon-paperclip-in-vertical-position.svg";
import question from "../assets/svg/icon-question.svg";

import ChangePasswordForm from "./PasswordChange";
import PersonalData from "./popups/PersonalData";
import CoWorkers from "./popups/CoWorkers";
import OurCompany from "./popups/OurCompany";
import Editing from "./popups/Editing";

const Navbar = () => {
  const [isShownPasswordForm, setIsShownPasswordForm] = useState(false);
  const [isShownDataForm, setIsShownDataForm] = useState(false);
  const [isShownCoWorkersForm, setIsShownCoWorkersForm] = useState(false);
  const [isShownCompanyForm, setIsShownCompanyForm] = useState(false);
  const [isShownEditingForm, setIsShownEditingForm] = useState(false);
  const changeIsDataFormOpen = () => {
    setIsShownDataForm(!isShownDataForm);
  };
  const changePassword = () => {
    setIsShownPasswordForm(!isShownPasswordForm);
  };
  const changeIsCoWorkersOpen = () => {
    setIsShownCoWorkersForm(!isShownCoWorkersForm);
  };
  const changeIsOurCompanyOpen = () => {
    setIsShownCompanyForm(!isShownCompanyForm);
  };
  const changeIsEditingForm = () => {
    setIsShownEditingForm(!isShownEditingForm);
  };
  const menuIcons = [
    {
      icon: home,
      clickHandler: changePassword,
    },
    {
      icon: document,
      clickHandler: null,
    },
    {
      icon: textDocument,
      clickHandler: null,
    },
    {
      icon: remove,
      clickHandler: null,
    },
    {
      icon: document1,
      clickHandler: null,
    },
    {
      icon: floppyDisk,
      clickHandler: null,
    },
    {
      icon: semicircular,
      clickHandler: null,
    },
    {
      icon: check,
      clickHandler: null,
    },
    {
      icon: recycling,
      clickHandler: null,
    },
    {
      icon: binoculars,
      clickHandler: null,
    },
    {
      icon: magnifier,
      clickHandler: null,
    },
    {
      icon: sort,
      clickHandler: null,
    },
    {
      icon: printer,
      clickHandler: null,
    },
    {
      icon: excel,
      clickHandler: null,
    },
    {
      icon: file,
      clickHandler: null,
    },
    {
      icon: paperclip,
      clickHandler: null,
    },
    {
      icon: question,
      clickHandler: null,
    },
  ];

  return (
    <nav className="navbar">
      {isShownPasswordForm && (
        <ChangePasswordForm changePassword={changePassword} />
      )}
      {isShownDataForm && (
        <PersonalData changeIsDataFormOpen={changeIsDataFormOpen} />
      )}
      {isShownCoWorkersForm && (
        <CoWorkers changeIsCoWorkersOpen={changeIsCoWorkersOpen} />
      )}
      {isShownCompanyForm && (
        <OurCompany changeIsOurCompanyOpen={changeIsOurCompanyOpen} />
      )}
      {isShownEditingForm && (
        <Editing changeIsEditingForm={changeIsEditingForm} />
      )}
      <div className="upperNav">
        <div className="upperNav-left">
          <button className="upperNav-btn" onClick={changeIsDataFormOpen}>
            Профиль
          </button>
          <Link to={"/clasificator"} className="upperNav-btn">
            Меню
          </Link>
          <button className="upperNav-btn" onClick={changeIsEditingForm}>
            Общее
          </button>
          <button className="upperNav-btn" onClick={changeIsOurCompanyOpen}>
            Действия
          </button>
          <button className="upperNav-btn" onClick={changeIsCoWorkersOpen}>
            Служебное
          </button>
        </div>
        <div className="upperNav-right">
          <Link to="#" className="upperNav-right__link">
            Наши расчетные счета
          </Link>
          <div className="upperNav-right__menu">
            <button className="upperNav-right__icon">
              <img src={minimize} alt="Minimize" />
            </button>
            <button className="upperNav-right__icon">
              <img src={rollUp} alt="Roll up" />
            </button>
            <button className="upperNav-right__icon">
              <img src={close} alt="Close" />
            </button>
          </div>
        </div>
      </div>

      <div className="middleNav">
        <div className="middleNav-left">
          <div className="middleNav-left1">
            {menuIcons.map((icon) => {
              return (
                // <Link to="/" key={icon} className='middleNav-link'>
                //  <img src={icon} alt={`${icon}`} className="middleNav-icon"/>
                // </Link>
                <button
                  key={icon.icon}
                  className="middleNav-link"
                  onClick={icon.clickHandler}
                >
                  <img
                    src={icon.icon}
                    alt={`${icon.icon}`}
                    className="middleNav-icon"
                  />
                </button>
              );
            })}
          </div>
          {/* <Link to="/" className='middleNav-link'>
                <img src={magnifier} alt="Magnifier" className="middleNav-icon"/>
                </Link> */}
          <button className="middleNav-link">
            <img src={magnifier} alt="Magnifier" className="middleNav-icon" />
          </button>
        </div>
        <div className="middleNav-right">
          <p className="middleNav-right__lang">РУС</p>
          <Link to={"/"}>
            <img src={logo} alt="Logo" className="middleNav-right__logo" />
          </Link>
        </div>
      </div>
      <div className="lowerNav">
        <div className="upperNav-left">
          <Link to={"/"} className="upperNav-btn">
            Наши расчетные счета
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Карточка
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Закладки
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Поиск
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Финансовые операции
          </Link>
        </div>
        <div className="upperNav-right">
          <div className="upperNav-right__menu">
            <button className="upperNav-right__icon">
              <img src={minimize} alt="Minimize" />
            </button>
            <button className="upperNav-right__icon">
              <img src={rollUp} alt="Roll up" />
            </button>
            <button className="upperNav-right__icon">
              <img src={close} alt="Close" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
